import { GroupedOption, Option, Options } from 'types/SelectInputs';

export function isGroupedOptions(x: object): boolean {
    return Object.keys(x).includes('options');
}

export function flattenOptions(options: Options): Option[] {
    const result: Option[] = [];
    for (const item of options) {
        if (isGroupedOptions(item)) {
            result.push(...(item as GroupedOption).options);
        } else {
            result.push(item as Option);
        }
    }
    return result;
}

export function valueToSelectOptionTranslator(value: string, options: Options): Option | undefined {
    let selected: Option | undefined;
    if (isGroupedOptions(options)) {
        const groupedOptions = options as GroupedOption[];
        groupedOptions.forEach((groupe) => {
            const selected = groupe.options.find((o) => o.value === value);
            if (selected) {
                return selected;
            }
        });
    } else {
        selected = (options as Option[]).find((o) => o.value === value);
    }
    return selected;
}
